<template>
  <van-image v-if="show" v-bind="$attrs" :fit="fit" :position="position" :round="round" :lazy-load="lazyLoad" :src="imgUrl" :loading-icon="loading" @error="handleError" >
    <template v-if="errorIcon" v-slot:error>
      <img class="err-img" :src="errorIcon"/>
    </template>
  </van-image>
</template>

<script setup>
import { validate } from '@ywxk/util/validate'
import { localPicAnalysis } from '@UTILS/pic'

// 定义
const props = defineProps({
  src: String,
  fit: {
    type: String,
    default: 'cover',
  },
  position: {
    type: String,
    default: 'center',
  },
  // 当图片宽高不相等且 fit 为 contain 或 scale-down 时，将无法填充一个完整的圆形。
  round: Boolean,
  lazyLoad: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: String,
    default: 'photo',
  },
  errorIcon: {
    type: String,
    default: null,
  },
})
const emit = defineEmits(['error'])

// <===================================== 图片相关 ======================================
const show = ref(false)
const imgUrl = computed(() => {
  if (!show.value || !props.src) return ''
  return localPicAnalysis(props.src)
})
watch(
  () => props.src,
  (src) => {
    show.value = validate(['img', 'dataUrl'], src)
  },
  {
    immediate: true,
  }
)
// ====================================== 图片相关 =====================================>


const handleError = (event) => emit('error', event);
</script>

<style lang="scss">
.van-image__error,
.van-image__loading {
  background: none;
}

.van-image {
  width: 100%;
  height: 100%;
}

.van-icon__image {
  width: 100%;
  height: 100%;
}

img {
  &[src=''],
  &:not([src]) {
    opacity: 0;
  }
}
.van-image{
  .err-img{
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>
